import { ButtonBlock } from '@coast/schemas';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { CardRenderContext } from '@shared/components/blocks/contexts/render';
import { API } from '@shared/types/api';
import { MBButtonBlockButton } from './button';

interface Props {
  block: ButtonBlock;
  card: API.CardFragment;
}

export function MBButtonBlock({ block: { buttons }, card }: Props) {
  const renderContext = useContext(CardRenderContext);
  return (
    <View
      center={buttons.length === 1}
      row
      paddingVertical={renderContext === 'detail' ? 2 : 1}
      paddingHorizontal={renderContext === 'detail' ? 3 : 2}
    >
      {buttons.map((button, idx) => (
        <MBButtonBlockButton key={idx} button={button} card={card} />
      ))}
    </View>
  );
}
